import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Helper } from 'app/common/helper';
import { Constant } from 'app/config/constants';
import { OptionTypeEnum } from 'app/dialog/dialog-extract-setting/dialog-extract-setting.component';
import { DataService } from 'app/service/data.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'custom-multiple-selection1',
  templateUrl: './custom-multiple-selection1.component.html',
  styleUrls: ['./custom-multiple-selection1.component.scss']
})
export class CustomMultipleSelectionComponent1 implements OnInit {
  @ViewChild('checkboxes', { static: false })
  checkboxes?: ElementRef;
  expanded = false;
  isCheckAllFilter: boolean = false;
  /**
   * label
   */
  labelContent: string = '';
  /**
   * list option checked out put
   */
  listOptionChecked: any = [];
  /**
   * list option data
   */
  @Input() listOption: any;
  /**
   * list option default
   */
  @Input() listOptionCheckedDefault: any;
  /**
   * event emit data output
   */
  @Output() eventEmit = new EventEmitter<any>();
  //constant
  public readonly OptionTypeEnum = OptionTypeEnum;
  constructor(private translateService: TranslateService, private dataService: DataService) {}
  ngOnInit(): void {
    this.listOptionChecked = this.listOptionCheckedDefault ?? [];
    this.listOption = this.getDefaultChecked();
    this.getLabelContent();

    this.dataService.currentData.subscribe(data => {
      if (data[0] == Constant.IS_CHANGE_TIME_ZONE) {
        this.getLabelContent();
      }
    });
  }

  /*
   * show Check boxes
   */
  showCheckboxes() {
    if (!this.checkboxes || !this.listOption || !this.listOption.length) {
      return;
    }
    if (!this.expanded) {
      this.checkboxes.nativeElement.style.display = 'block';
      this.expanded = true;
      this.listOption = this.getDefaultChecked();
      this.controlCheckAll();
    } else {
      this.checkboxes.nativeElement.style.display = 'none';
      this.expanded = false;
    }
  }
  /*
   * lock Select Box
   */
  lockSelectBox() {
    if (!this.checkboxes) {
      return;
    }
    if (this.expanded) {
      this.checkboxes.nativeElement.style.display = 'none';
      this.expanded = false;
    }
  }
  /*
   * checked
   */
  checked(index: number) {
    this.listOption[index].isChecked = !this.listOption[index].isChecked;
    this.getLabelContent();
    this.controlCheckAll();
    this.eventEmit.emit(this.listOptionChecked);
  }
  /*
   * check all Filter
   */
  checkAllFilter() {
    this.isCheckAllFilter = !this.isCheckAllFilter;
    this.listOption.forEach(element => {
      element.isChecked = this.isCheckAllFilter;
    });
    this.getLabelContent();
    this.eventEmit.emit(this.listOptionChecked);
  }

  /**
   * control Check All
   */
  controlCheckAll() {
    this.isCheckAllFilter = this.listOption.every(filter => filter?.isChecked);
  }
  /**
   * get Name Label
   */
  getLabelContent() {
    this.labelContent = '';
    this.listOptionChecked = this.listOption?.filter(option => option.isChecked);
    if (this.listOption?.every(data => data.isChecked)) {
      this.labelContent = this.translateService.instant('dialog-extraction-condition-setting.select-all-gates');
    } else {
      this.labelContent = this.listOptionChecked?.map(option => option.name).join(',');
    }
  }

  /**
   * set Default checked
   */
  getDefaultChecked(): any {
    if (!this.listOptionChecked || !this.listOptionChecked.length) {
      return this.listOption;
    }
    this.listOption?.forEach(element => {
      if (this.listOptionChecked.some((option: any) => option.gateId == element.gateId)) {
        element.isChecked = true;
      }
    });
    return this.listOption;
  }
}
